// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federbelastung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federbelastungDE: PageEntry = {
  id: "post.federbelastung",
  locale: "de",
  slug: "federbelastung",
  seo: {
    title: "Glossar: Federbelastung einfach erklärt | Dietz GmbH",
    description: "Die Federbelastung bezieht sich auf die Kräfte oder Lasten, die auf eine Feder wirken und sie verformen. In mechanischen Systemen werden Federn häufig als Elemente zur Speicherung ",
  },
  type: "post",
  h1: "Glossar: Federbelastung einfach erklärt",
  intro: "Die Federbelastung bezieht sich auf die Kräfte oder Lasten, die auf eine Feder wirken und sie verformen. In mechanischen Systemen werden Federn häufig als Elemente zur Speicherung und Übertragung von Energie eingesetzt. Die richtige Federbelastung ist entscheidend für die ordnungsgemäße Funktion eines Systems. Ingenieure berücksichtigen dabei verschiedene Faktoren wie die Belastungsdauer, die Belastungsart und die maximal zulässige Verformung der Feder. Eine präzise Berechnung und Analyse der Federbelastung führen zu einer optimalen Federauslegung in unterschiedlichen Anwendungen.",
  blocks: [

  ],
};
